import useInitOverlayV2 from 'modules/overlay-v2/ui/hooks/initializers/use-init-overlay-v2';
import useOverlayReadiness from 'modules/overlay-v2/ui/hooks/use-overlay-readiness';
import { useEffect } from 'react';
import { useFetchAvailableFeature } from 'shared/hooks/fetchering/use-fetch-available-feature';
import supabase from 'modules/core/supabase/supabase';
import useOverlayRouteParams from 'modules/overlay-v2/ui/hooks/use-overlay-route-params';

import { CanvasEventBoards } from '../components/canvas/canvas-event-boards';
import { CanvasStaticBoards } from '../components/canvas/canvas-static-boards';
import Joystick from '../components/joystick/joystick';
import OverlayConnectionIndicator from '../components/overlay-connection-indicator/overlay-connection-indicator';
import ReadinessChecklist from '../components/readiness-checklist/readiness-checklist';

function OverlayV2() {
  useInitOverlayV2();

  const readiness = useOverlayReadiness();

  useEffect(() => {
    window.onerror = function (msg, url, line, col, error) {
      supabase.overlayLogs.createError({
        comment: 'overlay - общий',
        message: error?.stack ?? msg.toString(),
      });
    };
  }, []);

  const { organizerId } = useOverlayRouteParams();
  const { data: feature } = useFetchAvailableFeature({ userTournamentId: organizerId });

  useEffect(() => {
    const rootDiv = document.getElementById('root');
    const body = document.getElementsByTagName('body')[0];
    rootDiv?.setAttribute('style', 'background: unset');
    body?.setAttribute('style', 'background: unset; overflow: hidden');
  }, []);

  // Пока подготовка не завершилась, вместо табло — чеклист: он объясняет, чего не хватает,
  // и сам повторяет упавшие шаги. Табло монтируется сразу, как только всё сошлось, а чеклист
  // ещё мгновение висит поверх и уходит анимацией — канва успевает подготовиться под ним.
  //
  // Монтируем по `isOnAir`, а не по `isReady`: последний означает «прямо сейчас все сигналы
  // сошлись» и падает в ноль от любой пересинхронизации или моргнувшей сети — вместе с ним
  // размонтировались бы канвы Fabric прямо в эфире.
  return (
    <>
      {readiness.isOnAir && (
        <div key={'overlay'} className={'flex justify-end'} style={{ width: '100%', height: '100vh' }}>
          <OverlayConnectionIndicator />
          <div
            className={'flex justify-end'}
            style={{
              background: 'unset',
              width: '100%',
              height: '100%',
              position: 'relative',
            }}
          >
            <CanvasStaticBoards />
            <CanvasEventBoards />
          </div>
          {feature?.OBS_INTEGRATION && <Joystick key={'FullSizeControlPanel-old'} />}
        </div>
      )}

      {readiness.isScreenVisible && <ReadinessChecklist readiness={readiness} onRetry={readiness.onRetry} />}
    </>
  );
}

export default OverlayV2;
